module.exports = __webpack_public_path__ + "img/267.f18acfe7.png";